const GroupSelect = {
  init(containerId, options, handleSelect, groupSelect, description) {
    this.containerId = containerId;
    this.container = $(`#${this.containerId}`);
    this.options = options;
    this.handleSelect = handleSelect;
    this.groupSelect = groupSelect;
    this.description = description;
    this.baseContainer = null;
    return this;
  },

  render() {
    const $select = this._renderSelect();
    this.baseContainer.find('input[type=checkbox]').on('change', this.groupSelect);
    this.baseContainer.find('input[type=checkbox]').on('change', function (e) {
      const select = $(e.target).parent().find('select');
      select.attr('disabled', !e.target.checked);
      const value = e.target.checked ? 'sectors' : '';
      select.attr('value', value);
    });
    $select.on('change', this.handleSelect);
  },

  _renderSelect() {
    let $selectContainer;
    if (this.container.find('.chart-options').length) {
      $selectContainer = this.container.find('.chart-options')
    } else {
      $selectContainer = $('<div>').addClass('chart-options').appendTo(this.container);
    }

    this.baseContainer = $('<div>').addClass('chart-group');
    this.baseContainer.appendTo($selectContainer);

    const description = I18n.t(`projects.index.selects.${this.description}`);
    $('<div>').addClass('breakdown-chart-select-description').text(description).appendTo(this.baseContainer);

    this.disableCheckbox = $("<input type='checkbox'>").addClass('breakdown-chart-select-disable-checkbox');
    this.disableCheckbox.prop('checked', false);
    this.disableCheckbox.appendTo(this.baseContainer);

    const $select = $('<select>').addClass('breakdown-chart-select');
    $select.attr('disabled', true);
    $select.appendTo(this.baseContainer);

    for (let option of this.options) {
      if (option !== '') {
        $("<option>").attr({ value: option }).text(I18n.t(`projects.index.headers.${option}`)).appendTo($select);
      }
    }
    return $select;
  }
};

export default GroupSelect;